import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/app/environments/environment';
import { Observable } from 'rxjs';
import {
  CreatePostingProfileRequest,
  PostingProfileResponse,
} from '../models/strategiesModel';
import { ProductCategoryResponse } from '../../../Models/productCategoriesModel';
import { ProductPostingProfileRuleMappingModel } from '../../product/models/product.model';

@Injectable({
  providedIn: 'root',
})
export class PostingProfilesService {
  baseUrl: string = environment.listerApiBaseUrl;

  constructor(private http: HttpClient) {}

  getPostingProfiles(
    companyId: number,
    categoryId?: number,
    sortCriteria?: string
  ): Observable<PostingProfileResponse[]> {
    let params = new HttpParams().set('CompanyId', companyId.toString());

    if (categoryId != null) {
      params = params.set('ProductCategoryId', categoryId.toString());
    }

    if (sortCriteria?.trim()) {
      params = params.set('SortCriteria', sortCriteria.trim());
    }

    return this.http.get<PostingProfileResponse[]>(
      `${this.baseUrl}/PostingProfiles`,
      {
        params,
      }
    );
  }

  getPostingProfileById(id: number) {
    const url = `${this.baseUrl}/PostingProfiles/${id}`;
    return this.http.get<PostingProfileResponse>(url);
  }

  createPostingProfile(data: CreatePostingProfileRequest) {
    const url = `${this.baseUrl}/PostingProfiles`;
    return this.http.post(url, data);
  }

  createBulkPostingProfiles(data: CreatePostingProfileRequest[]) {
    const url = `${this.baseUrl}/PostingProfiles/Bulk`;
    return this.http.post(url, data);
  }

  deletePostingProfile(id: number) {
    const url = `${this.baseUrl}/PostingProfiles/${id}`;
    return this.http.delete(url);
  }

  editPostingProfile(id: number, data: CreatePostingProfileRequest) {
    const url = `${this.baseUrl}/PostingProfiles/${id}`;
    return this.http.put(url, data);
  }

  getPostingProfileCategories() {
    const url = `${this.baseUrl}/PostingProfileCategories`;
    return this.http.get<ProductCategoryResponse[]>(url);
  }

    getPostingProfileMappings(
      productId: number
    ): Observable<ProductPostingProfileRuleMappingModel[]> {
      const url = `${this.baseUrl}/ProductPostingProfileRuleMappings?ProductId=${productId}`;
      return this.http.get<ProductPostingProfileRuleMappingModel[]>(url);
    }
}
